import { render, staticRenderFns } from "./ClientAnalyzesModal.vue?vue&type=template&id=990a7c94&"
import script from "./ClientAnalyzesModal.vue?vue&type=script&lang=js&"
export * from "./ClientAnalyzesModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientAnalyzesModal.vue?vue&type=style&index=0&id=990a7c94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports